function FoldArrow({ fill = '#A3A9C2' }: { fill?: string }) {
  return (
    <svg
      style={{ marginLeft: -6, marginRight: -6 }}
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
    >
      <path
        d="M7.75054 8.83705C7.66731 8.93486 7.54602 8.99383 7.41628 8.99953C7.28653 9.00532 7.16023 8.95731 7.06838 8.86724C6.97662 8.77718 6.92755 8.65345 6.93346 8.52624C6.93936 8.39895 6.99951 8.28002 7.09927 8.19852L10.4221 4.93698H0.439188C0.27955 4.9286 0.135534 4.84032 0.0581257 4.70323C-0.0193752 4.56622 -0.0193752 4.39972 0.0581257 4.26264C0.135536 4.12554 0.279545 4.03726 0.439188 4.02898H10.4221L7.09416 0.771088C7.01038 0.685036 6.96368 0.570743 6.96368 0.45182C6.96368 0.332898 7.01038 0.218527 7.09416 0.132553C7.18047 0.047658 7.29759 0 7.41979 0C7.54199 0 7.6592 0.047658 7.74542 0.132553L11.8614 4.16809C11.9499 4.25165 12 4.36683 12 4.48727C12 4.60779 11.9499 4.72307 11.8614 4.80653L7.75054 8.83705Z"
        fill={fill}
      />
    </svg>
  );
}

export default FoldArrow;
